import client from './client';

// dept: 'Phòng DVKH' (mặc định) hoặc 'Phòng kế toán' — quyết định đơn giá + lọc theo phòng.
export const listOvertime = (month, dept) => client.get('/overtime', { params: { month, dept } }).then((r) => r.data);
export const overtimeStaff = (dept) => client.get('/overtime/staff', { params: { dept } }).then((r) => r.data);
export const createOvertime = (payload) => client.post('/overtime', payload).then((r) => r.data);
export const updateOvertime = (id, payload) => client.patch(`/overtime/${id}`, payload).then((r) => r.data);
export const removeOvertime = (id) => client.delete(`/overtime/${id}`).then((r) => r.data);
